var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLastGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999913 3.41L5.57991 8L0.999912 12.59L2.40991 14L8.40991 8L2.40991 2L0.999913 3.41Z",
    fill: "#F0EDEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99991 3.41L11.5799 8L6.99991 12.59L8.40991 14L14.4099 8L8.40991 2L6.99991 3.41Z",
    fill: "#F0EDEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastGrey);
export default __webpack_public_path__ + "static/media/lastGrey.6c9e1b1854f241eeb7be1554028598ba.svg";
export { ForwardRef as ReactComponent };